export const version = '3.3.1'
export const name = 'js-libp2p'
